<div class="information-page">
    <div class="container information-shell">
        <section id="top" class="hero-section">
            <div class="hero-copy">
                <h1 [innerHTML]="'MOON_INFORMATION.TITLE' | translate"></h1>
                <p class="hero-intro">{{ 'MOON_INFORMATION.INTRO' | translate }}</p>
                <p class="orientation-line">
                    <img alt="" src="assets/images/information/star.webp">
                    <strong>{{ 'MOON_INFORMATION.ORIENTATION' | translate }}</strong>
                    <img alt="" src="assets/images/information/star.webp">
                </p>

                <div class="hero-actions">
                    <a class="primary-button" [routerLink]="languageService.route('/day')">
                        {{ 'MOON_INFORMATION.CTA_CALENDAR_VIEW' | translate }}
                    </a>
                    <a class="secondary-button" [routerLink]="[]" fragment="basics">
                        {{ 'MOON_INFORMATION.CTA_BASICS' | translate }}
                    </a>
                </div>
            </div>

            <div class="hero-visual" aria-hidden="true">
                <img alt="" src="assets/images/information/moon_information.webp">
            </div>
        </section>

        <section class="anchor-cards" aria-label="Moon information overview">
            @for (section of navSections; track section) {
                <a class="anchor-card" [routerLink]="[]" [fragment]="section.toLowerCase()">
                    <span class="anchor-icon">
                        @if (section === 'BASICS') {
                            <img alt="" src="assets/images/information/menu_basics.webp">
                        } @else if (section === 'PURPOSE') {
                            <img alt="" src="assets/images/information/menu_why.webp">
                        } @else if (section === 'FUNCTION') {
                            <img alt="" src="assets/images/information/menu_how.webp">
                        } @else if (section === 'SIGNS') {
                            <img alt="" src="assets/images/information/menu_sign.webp">
                        } @else if (section === 'NOTE') {
                            <img alt="" src="assets/images/information/menu_order.webp">
                        }
                    </span>
                    <strong>{{ 'MOON_INFORMATION.NAV.' + section | translate }}</strong>
                    <small>{{ 'MOON_INFORMATION.NAV_HINTS.' + section | translate }}</small>
                </a>
            }
        </section>

        <section id="basics" class="basics-grid">
            <article class="text-panel">
                <h2>{{ 'MOON_INFORMATION.WHAT_TITLE' | translate }}</h2>
                <p [innerHTML]="'MOON_INFORMATION.WHAT_TEXT_1' | translate"></p>
                <p [innerHTML]="'MOON_INFORMATION.WHAT_TEXT_2' | translate"></p>
                <blockquote>
                    <img alt="" src="assets/images/information/quotes.webp">
                    <span>{{ 'MOON_INFORMATION.USE_QUOTE' | translate }}</span>
                </blockquote>
            </article>

            <article class="formula-panel">
                <h2>{{ 'MOON_INFORMATION.FORMULA_TITLE' | translate }}</h2>
                <div class="formula-row">
                    @for (part of formulaParts; track part; let last = $last) {
                        <div class="formula-part">
                            <span><img alt="" [src]="formulaIcon(part)"></span>
                            <strong>{{ 'MOON_INFORMATION.FORMULA.' + part + '.TITLE' | translate }}</strong>
                            <p>{{ 'MOON_INFORMATION.FORMULA.' + part + '.TEXT' | translate }}</p>
                        </div>
                        @if (!last) {
                            <span class="formula-plus">✦</span>
                        }
                    }
                </div>

                <div class="formula-example">
                    <h3>{{ 'MOON_INFORMATION.FORMULA_EXAMPLE_TITLE' | translate }}</h3>
                    <div class="example-row">
                        @for (part of formulaParts; track part; let last = $last) {
                            @if (part !== 'RECOMMENDATION') {
                                <div class="example-part">
                                    <span class="example-icon">
                                        @if (exampleIcon(part); as icon) {
                                            <img alt="" [src]="icon">
                                        } @else {
                                            {{ 'MOON_INFORMATION.FORMULA.' + part + '.ICON' | translate }}
                                        }
                                    </span>
                                    <div>
                                        <strong>{{ 'MOON_INFORMATION.FORMULA.' + part + '.EXAMPLE' | translate }}</strong>
                                        <small>{{ 'MOON_INFORMATION.FORMULA.' + part + '.EXAMPLE_TEXT' | translate }}</small>
                                    </div>
                                </div>
                            } @else {
                                <span class="example-arrow">&rarr;</span>
                                <div class="example-part recommendation-example">
                                    <span class="example-icon">{{ 'MOON_INFORMATION.FORMULA.' + part + '.ICON' | translate }}</span>
                                    <div>
                                        <strong>{{ 'MOON_INFORMATION.FORMULA.' + part + '.EXAMPLE' | translate }}</strong>
                                        <small>{{ 'MOON_INFORMATION.FORMULA.' + part + '.EXAMPLE_TEXT' | translate }}</small>
                                    </div>
                                </div>
                            }
                        }
                    </div>
                    <p class="example-note">
                        <img alt="" src="assets/images/information/flower.webp">
                        <span>{{ 'MOON_INFORMATION.FORMULA_EXAMPLE_NOTE' | translate }}</span>
                    </p>
                </div>
            </article>
        </section>

        <section class="content-section" id="purpose">
            <div class="center-heading">
                <h2>{{ 'MOON_INFORMATION.USE_TITLE' | translate }}</h2>
                <p>{{ 'MOON_INFORMATION.USE_TEXT' | translate }}</p>
            </div>

            <div class="area-grid">
                @for (area of recommendationAreas; track area) {
                    <article class="area-card">
                        <span>{{ 'MOON_INFORMATION.AREA_ICONS.' + area | translate }}</span>
                        <h3>{{ 'MOON_INFORMATION.AREAS.' + area | translate }}</h3>
                        <p>{{ 'MOON_INFORMATION.AREA_TEXTS.' + area | translate }}</p>
                    </article>
                }
            </div>
        </section>

        <section class="content-section" id="function">
            <div class="center-heading">
                <h2>{{ 'MOON_INFORMATION.FUNCTION_TITLE' | translate }}</h2>
                <p>{{ 'MOON_INFORMATION.FUNCTION_TEXT' | translate }}</p>
            </div>

            <div class="process-grid">
                @for (card of processCards; track card; let index = $index) {
                    <article class="process-card" [class.dark-card]="card === 'PHASES'" [class.image-card]="card === 'SIGNS'">
                        <span class="step-number">{{ index + 1 }}</span>
                        <h3>{{ 'MOON_INFORMATION.PROCESS.' + card + '.TITLE' | translate }}</h3>
                        <p>{{ 'MOON_INFORMATION.PROCESS.' + card + '.TEXT' | translate }}</p>

                        @if (card === 'PHASES') {
                            <div class="phase-list">
                                @for (phase of phases; track phase) {
                                    <div>
                                        <span>{{ 'MOON_INFORMATION.PHASES.' + phase + '.SYMBOL' | translate }}</span>
                                        <strong>{{ 'MOON_INFORMATION.PHASES.' + phase + '.TITLE' | translate }}</strong>
                                        <small>{{ 'MOON_INFORMATION.PHASES.' + phase + '.SHORT' | translate }}</small>
                                    </div>
                                }
                            </div>
                        }

                        @if (card === 'ZODIAC') {
                            <div class="zodiac-wheel" aria-hidden="true">
                                <img alt="" src="assets/images/information/menu_sign.webp">
                            </div>
                            <p class="mini-example">{{ 'MOON_INFORMATION.EXAMPLE_TEXT' | translate }}</p>
                        }

                        @if (card === 'ELEMENTS') {
                            <div class="mini-elements">
                                @for (element of elements; track element) {
                                    <div>
                                        <span class="asset-icon"><img alt="" [src]="elementIcon(element)"></span>
                                        <strong>{{ 'MOON_INFORMATION.ELEMENTS.' + element + '.SUMMARY' | translate }}</strong>
                                        <small>{{ 'MOON_INFORMATION.ELEMENTS.' + element + '.SIGNS' | translate }}</small>
                                    </div>
                                }
                            </div>
                        }

                        @if (card === 'SIGNS') {
                            <img alt="" src="assets/images/error_moon.webp">
                            <a class="small-button" [routerLink]="[]" fragment="signs">{{ 'MOON_INFORMATION.CTA_SIGNS' | translate }}</a>
                        }
                    </article>
                }
            </div>
        </section>

        <section class="content-section" id="signs">
            <div class="center-heading">
                <p class="kicker">{{ 'MOON_INFORMATION.SECTION_SIGNS_KICKER' | translate }}</p>
                <h2>{{ 'MOON_INFORMATION.SIGNS_TITLE' | translate }}</h2>
                <p>{{ 'MOON_INFORMATION.SIGNS_TEXT' | translate }}</p>
            </div>

            <div class="sign-grid">
                @for (sign of zodiacSigns; track sign) {
                    <article class="sign-card">
                        <span class="sign-icon"><img alt="" [src]="zodiacIcon(sign)"></span>
                        <h3>{{ 'MOON_INFORMATION.ZODIAC_SIGNS.' + sign + '.TITLE' | translate }}</h3>
                        <small>{{ 'MOON_INFORMATION.ZODIAC_SIGNS.' + sign + '.ELEMENT' | translate }}</small>
                        <p>{{ 'MOON_INFORMATION.ZODIAC_SIGNS.' + sign + '.BODY' | translate }}</p>
                    </article>
                }
            </div>

            <div class="sign-example-grid">
                <article class="aries-example-card">
                    <div class="aries-copy">
                        <div class="aries-heading">
                            <img alt="" src="assets/images/information/aries_example.webp">
                            <div>
                                <h2>{{ 'MOON_INFORMATION.ARIES_EXAMPLE.TITLE' | translate }}</h2>
                                <strong>{{ 'MOON_INFORMATION.ARIES_EXAMPLE.ELEMENT' | translate }}</strong>
                                <p>{{ 'MOON_INFORMATION.ARIES_EXAMPLE.BODY' | translate }}</p>
                            </div>
                        </div>

                        <p class="aries-description" [innerHTML]="'MOON_INFORMATION.ARIES_EXAMPLE.DESCRIPTION' | translate"></p>

                        <div class="meaning-card">
                            <h3>{{ 'MOON_INFORMATION.ARIES_EXAMPLE.MEANING_TITLE' | translate }}</h3>
                            <ul>
                                <li>{{ 'MOON_INFORMATION.ARIES_EXAMPLE.MEANING_1' | translate }}</li>
                                <li>{{ 'MOON_INFORMATION.ARIES_EXAMPLE.MEANING_2' | translate }}</li>
                                <li>{{ 'MOON_INFORMATION.ARIES_EXAMPLE.MEANING_3' | translate }}</li>
                            </ul>
                        </div>

                        <div class="recommendation-lines">
                            <div>
                                <img alt="" src="assets/images/information/aries_positive.webp">
                                <p><strong>{{ 'MOON_INFORMATION.ARIES_EXAMPLE.FAVORABLE_TITLE' | translate }}</strong>{{ 'MOON_INFORMATION.ARIES_EXAMPLE.FAVORABLE_TEXT' | translate }}</p>
                            </div>
                            <div>
                                <img alt="" src="assets/images/information/aries_negative.webp">
                                <p><strong>{{ 'MOON_INFORMATION.ARIES_EXAMPLE.UNFAVORABLE_TITLE' | translate }}</strong>{{ 'MOON_INFORMATION.ARIES_EXAMPLE.UNFAVORABLE_TEXT' | translate }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="aries-visual" aria-hidden="true">
                        <img alt="" src="assets/images/information/aries_big.webp">
                        <div class="short-card">
                            <h3>{{ 'MOON_INFORMATION.ARIES_EXAMPLE.SHORT_TITLE' | translate }}</h3>
                            <p>{{ 'MOON_INFORMATION.ARIES_EXAMPLE.SHORT_TEXT' | translate }}</p>
                        </div>
                    </div>
                </article>

                <article class="aries-example-card virgo-example-card">
                    <div class="aries-copy">
                        <div class="aries-heading">
                            <img alt="" src="assets/images/information/virgo_example.webp">
                            <div>
                                <h2>{{ 'MOON_INFORMATION.VIRGO_EXAMPLE.TITLE' | translate }}</h2>
                                <strong>{{ 'MOON_INFORMATION.VIRGO_EXAMPLE.ELEMENT' | translate }}</strong>
                                <p>{{ 'MOON_INFORMATION.VIRGO_EXAMPLE.BODY' | translate }}</p>
                            </div>
                        </div>

                        <p class="aries-description" [innerHTML]="'MOON_INFORMATION.VIRGO_EXAMPLE.DESCRIPTION' | translate"></p>

                        <div class="meaning-card">
                            <h3>{{ 'MOON_INFORMATION.VIRGO_EXAMPLE.MEANING_TITLE' | translate }}</h3>
                            <ul>
                                <li>{{ 'MOON_INFORMATION.VIRGO_EXAMPLE.MEANING_1' | translate }}</li>
                                <li>{{ 'MOON_INFORMATION.VIRGO_EXAMPLE.MEANING_2' | translate }}</li>
                                <li>{{ 'MOON_INFORMATION.VIRGO_EXAMPLE.MEANING_3' | translate }}</li>
                            </ul>
                        </div>

                        <div class="recommendation-lines">
                            <div>
                                <img alt="" src="assets/images/information/virgo_positive.webp">
                                <p><strong>{{ 'MOON_INFORMATION.VIRGO_EXAMPLE.FAVORABLE_TITLE' | translate }}</strong>{{ 'MOON_INFORMATION.VIRGO_EXAMPLE.FAVORABLE_TEXT' | translate }}</p>
                            </div>
                            <div>
                                <img alt="" src="assets/images/information/virgo_negative.webp">
                                <p><strong>{{ 'MOON_INFORMATION.VIRGO_EXAMPLE.UNFAVORABLE_TITLE' | translate }}</strong>{{ 'MOON_INFORMATION.VIRGO_EXAMPLE.UNFAVORABLE_TEXT' | translate }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="aries-visual" aria-hidden="true">
                        <img alt="" src="assets/images/information/virgo_big.webp">
                        <div class="short-card">
                            <h3>{{ 'MOON_INFORMATION.VIRGO_EXAMPLE.SHORT_TITLE' | translate }}</h3>
                            <p>{{ 'MOON_INFORMATION.VIRGO_EXAMPLE.SHORT_TEXT' | translate }}</p>
                        </div>
                    </div>
                </article>
            </div>
        </section>

        <section class="bottom-grid" id="note">
            <article class="text-panel note-panel">
                <p class="kicker">{{ 'MOON_INFORMATION.SECTION_NOTE_KICKER' | translate }}</p>
                <h2>{{ 'MOON_INFORMATION.NOTE_TITLE' | translate }}</h2>
                <p>{{ 'MOON_INFORMATION.NOTE_INTRO' | translate }}</p>

                <div class="knowledge-columns">
                    <div class="astronomy-knowledge">
                        <div class="knowledge-heading">
                            <span class="knowledge-badge"><img alt="" src="assets/images/information/knowledge_astronomy.webp"></span>
                            <h3 [innerHTML]="'MOON_INFORMATION.NOTE_ASTRONOMY_TITLE' | translate"></h3>
                        </div>
                        <ul>
                            @for (item of astronomyItems; track item) {
                                <li>{{ 'MOON_INFORMATION.NOTE_ASTRONOMY.' + item | translate }}</li>
                            }
                        </ul>
                    </div>

                    <div class="tradition-knowledge">
                        <div class="knowledge-heading">
                            <span class="knowledge-badge"><img alt="" src="assets/images/information/knowledge_learned.webp"></span>
                            <h3 [innerHTML]="'MOON_INFORMATION.NOTE_TRADITION_TITLE' | translate"></h3>
                        </div>
                        <ul>
                            @for (item of traditionItems; track item) {
                                <li>{{ 'MOON_INFORMATION.NOTE_TRADITION.' + item | translate }}</li>
                            }
                        </ul>
                    </div>
                </div>

                <strong>{{ 'MOON_INFORMATION.NOTE_CLOSING' | translate }}</strong>
            </article>
        </section>

    </div>
</div>
